import { ChatProcessingIcon } from './ChatProcessingIcon';

/**
 * author: Austin Andrews
 * id 95003FC4-C655-4687-AF82-660A49B95978
 * name chat-processing
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chat-processing.svg
 * tags
 */
export const ChatTypingIcon = ChatProcessingIcon;
export default ChatTypingIcon